<template>
  <div class="container">

    <div class="row">
      <div class="col-lg-3 my-2 text-center" v-for="item in generateLinks">

        <div class="p-2 justify-content-center d-flex link-tool-kit-item rounded-lg ">
          <a target="_blank" class="text-dark" :href="item.value">
            {{ item.name }}
          </a>

          <b-icon @click="copyLink(item)" class="h4 mx-1" icon='clipboard-check'/>

        </div>

      </div>
    </div>


  </div>
</template>

<script>
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";

export default {
  name: "LinkToolKit",
  computed: {
    generateLinks() {

      let apiLink = findAttributeOnSiteInfo('host')[0]

      let result = {}

      let baseItemObject = {
        name: "",
        value: "",
      }


      // torob api
      result['torobApi'] = Object.assign({}, baseItemObject)
      result['torobApi'].name = 'لینک api ترب'
      result['torobApi'].value = `${apiLink}/api/store/api/get/torob/products`


      // torob offer section
      result['torobOfferApi'] = Object.assign({}, baseItemObject)
      result['torobOfferApi'].name = 'لینک api ترب برای تخفیفات'
      result['torobOfferApi'].value = `${apiLink}/store/api/get/torob/products`

      // torob v3
      result['torobV3Api'] = Object.assign({}, baseItemObject)
      result['torobV3Api'].name = 'لینک api ترب v3'
      result['torobV3Api'].value = `${apiLink}/v3/torob`


      // emalls
      result['emallsApi'] = Object.assign({}, baseItemObject)
      result['emallsApi'].name = 'لینک api ایمالز'
      result['emallsApi'].value = `${apiLink}/api/store/api/get/emalls/products`

      // zarehbin
      result['zarehbinApi'] = Object.assign({}, baseItemObject)
      result['zarehbinApi'].name = 'لینک api ذره بین'
      result['zarehbinApi'].value = `${apiLink}/api/store/api/get/zarehbin/products`

      // zarehbin
      result['sitemap'] = Object.assign({}, baseItemObject)
      result['sitemap'].name = 'سایت مپ'
      result['sitemap'].value = `${apiLink}/api/sitemap.xml`


      return result


    }
  },
  methods: {
    copyLink(link) {

      navigator.clipboard.writeText(link.value).then(function () {
        toast('کپی با موفقیت انجام شد', 'کپی با موفقیت انجام شد')
      }, function (err) {
        console.log('Copy Error => ', err)
      })

    }
  }
}
</script>

<style scoped>
.link-tool-kit-item {
  background: #cfcfcf;
}
</style>